import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';
import Upperbox from '../components/Upperbox';

export const Payroll = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
       <Upperbox />
       <NavBar />
      <div className='tax-page'>
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">Payroll Processing Services</h1>
            <Link to="/businessservicespage" className="tax-notification-body">Go Back</Link>
          </div>
        </div>

        <div className='tax-content-container'>
          <h1 className='tax-section-title'>
            Efficient Payroll Processing and Maintenance at Sumukha Tax Filers.
          </h1>
          <p className='tax-section-description'>
            Managing payroll is a critical aspect of running a business, but it can also be time-consuming and complex. At Sumukha Tax Filers., we provide comprehensive payroll processing and maintenance services designed to simplify the payroll experience for your business. Our team of experienced Certified Public Accountants (CPAs) and Enrolled Agents (EAs) ensures that your payroll is processed accurately and in compliance with all federal and state regulations.
          </p>
          <h2 className='tax-subheading'>Why Choose Sumukha Tax Filers. for Payroll Processing?</h2>
          <ul className='tax-section-description'>
            <li><strong>Expertise:</strong> Our knowledgeable team understands the intricacies of payroll laws and regulations, ensuring your payroll is handled correctly and on time.</li>
            <li><strong>Customized Solutions:</strong> We offer tailored payroll services that fit the specific needs of your business, whether you have a few employees or a large workforce.</li>
            <li><strong>Focus on Your Business:</strong> By outsourcing payroll processing to us, you can free up valuable time and resources, allowing you to concentrate on growing your business.</li>
          </ul>
          <h2 className='tax-subheading'>Our Payroll Processing and Maintenance Services</h2>
          <p className='tax-section-description'>
            At Sumukha Tax Filers., we offer a full suite of payroll processing and maintenance services, including:
          </p>
          <ol className='tax-section-description'>
            <li><strong>Payroll Processing:</strong> We handle the entire payroll process, from calculating employee wages and deductions to processing payroll checks and direct deposits, ensuring that your employees are paid accurately and on time.</li>
            <li><strong>Tax Withholding and Reporting:</strong> Our team ensures proper federal, state, and local tax withholding for each employee and handles all payroll tax reporting, including Form 941, Form 940, and state payroll tax forms.</li>
            <li><strong>Employee Benefits Administration:</strong> We assist in managing employee benefits, such as health insurance, retirement plans, and paid time off (PTO), ensuring accurate deductions and compliance with regulations.</li>
            <li><strong>Time and Attendance Tracking:</strong> We implement systems to accurately track employee hours worked, overtime, and leave, providing reliable data for payroll processing.</li>
            <li><strong>Year-End Reporting:</strong> Our team prepares and distributes year-end tax documents, such as Form W-2 for employees and Form 1099 for independent contractors, ensuring compliance with IRS requirements.</li>
            <li><strong>Compliance Monitoring:</strong> We stay up to date on changes in payroll laws and regulations, helping your business maintain compliance and avoid penalties.</li>
            <li><strong>Payroll Record Maintenance:</strong> We maintain detailed records of all payroll transactions, including employee earnings, deductions, and tax filings, ensuring you have access to accurate and organized financial data.</li>
            <li><strong>Consulting Services:</strong> Our CPAs and EAs are available to provide guidance on payroll best practices, employee classifications, and compliance issues.</li>
          </ol>
          <h2 className='tax-subheading'>Get Started Today</h2>
          <p className='tax-section-description'>
            At Sumukha Tax Filers., we understand the importance of efficient payroll processing for your business. Our expert CPAs and EAs are committed to providing reliable and accurate payroll services, allowing you to focus on your core operations. Contact us today to schedule a consultation and discover how we can support your payroll processing needs!
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};
export default Payroll;